<template>
    <div
        aria-live="assertive"
        class="
            fixed
            inset-0
            flex
            items-end
            px-4
            py-6
            pointer-events-none
            sm:p-6
            z-50
        "
        @click="show = false"
        :class="{
            'sm:items-center bg-alert': message.position == 'center',
            'sm:items-start ': message.position != 'center',
        }"
        v-if="show"
    >
        <div
            class="w-full flex flex-col items-center space-y-4"
            :class="{
                'sm:items-end': !message.position,
                'content-end': message.position == 'center',
            }"
        >
            <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
            <transition
                enter-active-class="transform ease-out duration-300 transition"
                enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition ease-in duration-100"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <div
                    class="
                        max-w-sm
                        w-full
                        shadow-2xl
                        rounded-lg
                        pointer-events-auto
                        ring-1 ring-black ring-opacity-5
                        overflow-hidden
                        bg-white
                    "
                    no-class="{
                        'bg-white': message.type != 'alert',
                        'bg-red-300': message.type == 'alert',
                    }"
                >
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="flex-shrink-0">
                                <CheckCircleIcon
                                    class="h-6 w-6 text-green-400"
                                    v-if="message.type == 'success'"
                                />
                                <ExclamationIcon
                                    class="h-6 w-6 text-red-400"
                                    v-if="message.type == 'error'"
                                />
                                <BellIcon
                                    class="h-6 w-6 text-indigo-400"
                                    v-if="message.type == 'alert'"
                                />
                            </div>
                            <div class="ml-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium text-gray-900">
                                    {{ message.title }}
                                </p>
                                <p
                                    class="mt-1 text-sm text-gray-500"
                                    v-html="message.message"
                                ></p>
                            </div>
                            <div class="ml-4 flex-shrink-0 flex">
                                <button
                                    @click="show = false"
                                    class="
                                        bg-white
                                        rounded-md
                                        inline-flex
                                        text-gray-400
                                        hover:text-gray-500
                                        focus:outline-none
                                        focus:ring-2
                                        focus:ring-offset-2
                                        focus:ring-indigo-500
                                    "
                                >
                                    <span class="sr-only">&cross;</span>
                                    <XIcon class="h-5 w-5" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { ref } from "vue";
import {
    CheckCircleIcon,
    ExclamationIcon,
    BellIcon,
} from "@heroicons/vue/outline";
import { XIcon } from "@heroicons/vue/solid";

export default {
    components: {
        CheckCircleIcon,
        XIcon,
        ExclamationIcon,
        BellIcon,
    },
    mounted() {},
    created() {
        let self = this;
        this.message = this.notification;
    },
    props: ["notification"],
    setup() {
        const show = ref(true);

        return {
            show,
            message: {},
        };
    },
};
</script>
<style scoped>
.bg-alert {
    background: rgba(0, 0, 0, 0.6) !important;
}
</style>
